var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.333C11.3137 12.333 14 9.64672 14 6.33301C14 3.0193 11.3137 0.333008 8 0.333008C4.68629 0.333008 2 3.0193 2 6.33301C2 9.64672 4.68629 12.333 8 12.333Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.33398C8.55228 7.33398 9 6.88627 9 6.33398C9 5.7817 8.55228 5.33398 8 5.33398C7.44772 5.33398 7 5.7817 7 6.33398C7 6.88627 7.44772 7.33398 8 7.33398Z",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75065 6.9919C10.5615 9.04565 10.6673 9.09107 10.6673 9.49982C10.6673 10.4082 8.91357 10.9998 8.00065 10.9998C7.08773 10.9998 5.33398 10.4098 5.33398 9.49982C5.33398 9.08648 5.45023 9.03148 7.25273 6.99023",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8054 5.35753C6.9329 2.76086 6.94665 2.64669 6.59165 2.44086C5.80457 1.98711 4.41749 3.21086 3.95915 4.00003C3.50082 4.78919 3.13665 6.60461 3.92374 7.05919C4.28124 7.26753 4.38707 7.19253 7.05582 6.65211",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19531 5.35753C9.06781 2.76086 9.05406 2.64669 9.40906 2.44086C10.1961 1.98711 11.5832 3.21086 12.0416 4.00003C12.4999 4.78919 12.8641 6.60461 12.077 7.05919C11.7195 7.26753 11.6136 7.19253 8.9449 6.65211",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 12.2939V13.6664C7.33333 13.8433 7.2631 14.0128 7.13807 14.1379C7.01305 14.2629 6.84348 14.3331 6.66667 14.3331H4.66667C4.48986 14.3331 4.32029 14.4033 4.19526 14.5284C4.07024 14.6534 4 14.823 4 14.9998V15.6664H12V14.9998C12 14.823 11.9298 14.6534 11.8047 14.5284C11.6797 14.4033 11.5101 14.3331 11.3333 14.3331H9.33333C9.15652 14.3331 8.98695 14.2629 8.86193 14.1379C8.7369 14.0128 8.66667 13.8433 8.66667 13.6664V12.2939",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.334 13.333V14.333",
    stroke: "#323232",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFan);
export default __webpack_public_path__ + "static/media/fan.8d4baa42.svg";
export { ForwardRef as ReactComponent };